export const calcularTotalItemConIva = (item) => {
  const alicuota = Number(item?.alicuota) || 0
  return calcularTotalItemSinIva(item) * (1 + alicuota / 100)
}

export const calcularTotalItemSinIva = (item) => {
  if (
    item.preciosMayoristas &&
    item.preciosMayoristas.length > 0 &&
    item.preciosMayoristas[0].cantidad > 0
  ) {
    const preciosOrdenados = item.preciosMayoristas.sort(
      (a, b) => b.cantidad - a.cantidad
    )

    const precioMayorista = preciosOrdenados.find((p) => item.cantidad >= p.cantidad)

    if (precioMayorista) {
      return item.cantidad * precioMayorista.precioUnitario
    }
  }

  return item.precioUnitario * (item.cantidad || 1)
}
